import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = (props) => {
  const { orderDataMonthly } = props;

  const defaultData = {
    labels: [
      'January-2024', 'February-2024', 'March-2024', 'April-2024',
      'May-2024', 'June-2024', 'July-2024', 'August-2024',
      'September-2024', 'October-2024', 'November-2024', 'December-2024'
    ],
    datasets: [
      {
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Default data
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        barThickness: 10,
      },
    ],
  };

  // Update the dataset with the data from orderDataMonthly
  const updatedData = { ...defaultData }; // Clone the default data object

  orderDataMonthly.forEach((order) => {
    const index = updatedData.labels.indexOf(order.monthYear); // Find the index of the month
    if (index !== -1) {
      updatedData.datasets[0].data[index] = order.totalOrderAmount; // Update the corresponding value
    }
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: '',
      },
    },
  };

  return (
    <div>
      <Bar data={updatedData } options={options} />
    </div>
  );
};

export default BarChart;
